import React, { useState, useEffect } from "react"
import { useParams } from 'react-router-dom';
import styles from './PaymentsHeader.module.scss'
import { TopRightIcon, Svg } from '../../index'
import { PageHeader, Star, CurrencyBadge } from '../../index'
import {themeColors, radius} from '../../../constants'

// Thin-stroke magnifier that matches the outline gear / chevron / star icons.
const SearchIcon = ({ color }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="11" cy="11" r="6.5" stroke={color} strokeWidth="2.2" />
    <path d="M16 16 L21 21" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
  </svg>
)

function PaymentsHeader({
  paymentSize,
  index,
  selectAll,
  handleSelectAllClick,
  editMode,
  accountingBookDetails,
  handleSmallChange,
  loading,
  onSearchClick,
  searchActive,
  backLink
}){
  /* eslint-disable no-unused-vars */
  const [showDisclamier, setShowDisclaimer] = useState(false)
  const { group_id, accounting_book_id } = useParams()

  useEffect(() => {
    if (accountingBookDetails.current !== undefined) {
      setShowDisclaimer(!accountingBookDetails.current)
    }
  }, [accountingBookDetails])

  const disclaimerClosed = () => {
    setShowDisclaimer(false)
  }

  let classes = [styles.header]
  let iconClasses = [styles.icon, styles.barsIcon]
  let nameClasses = [styles.name]
  let innerBlockClasses = [styles.innerBlock]

  return(
    <div>
      <PageHeader
        faicon='faChevronLeft'
        link={backLink || `/liff_entry/groups/${group_id}/accounting_books`}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {accountingBookDetails.name}
          <Star solid={accountingBookDetails.current} style={{ paddingLeft: '4px', display: 'inline-flex', alignItems: 'center' }}/>
          {
            accountingBookDetails.currency &&
              <CurrencyBadge currency={accountingBookDetails.currency} style={{ marginLeft: '8px' }} />
          }
        </span>

        {/* 編輯歷史 (log_messages) hidden — the history page loads too slowly for users.
            Re-enable when the log_messages endpoint is fast enough.
        <TopRightIcon
          style={{ fontSize: '20px', right: 58 }}
          link={`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/log_messages`} >
          <Svg
            icon='time'
            size='24'
            className='black' />
        </TopRightIcon>
        */}
        {
          onSearchClick &&
            <TopRightIcon
              style={{ fontSize: '20px', right: 52 }}
              clicked={onSearchClick}>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '34px',
                  height: '34px',
                  borderRadius: radius.circle,
                  position: 'relative',
                  background: searchActive ? 'rgba(12, 83, 60, 0.12)' : 'transparent',
                  transition: 'background 0.15s ease',
                }}>
                <SearchIcon color={searchActive ? themeColors.green700 : themeColors.gray900} />
              </span>
            </TopRightIcon>
        }
        <TopRightIcon
          style={{ fontSize: '20px', right: 20 }}
          link={`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/settings`}>
          <Svg
            icon='setting'
            size='24'
            className='black' />
        </TopRightIcon>

      </PageHeader>
    </div>
  )
}

export default PaymentsHeader
